import { render, staticRenderFns } from "./bouton-card.vue?vue&type=template&id=23339bb6&scoped=true&"
import script from "./bouton-card.vue?vue&type=script&lang=ts&"
export * from "./bouton-card.vue?vue&type=script&lang=ts&"
import style0 from "./bouton-card.vue?vue&type=style&index=0&id=23339bb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23339bb6",
  null
  
)

export default component.exports